import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const state = {

  callingAPI: false,
  searching: "",
  user: null,
  token: null,
  userInfo: {
    messages: [],
    notifications: [],
    tasks: []
  }
}

const actions = {
  updateToken ({ commit }, { token }) {
    // console.log(user)
    commit("setToken", token)
  },
  updateUser ({ commit }, { user, token }) {
    // console.log(user)
    commit("setToken", token)
    commit("setUser", user)
  },
  logout ({ commit }) {
    commit("setToken", null)
    commit("setUser", {})
  }
}

const mutations = {
  loginLoading (state) {
    state.callingAPI = !state.callingAPI
  },
  globalSearching (state) {
    state.searching = state.searching === "" ? "loading" : ""
  },
  setUser (state, user) {
    state.user = user
  },
  setToken (state, token) {
    localStorage.token = token
    state.token = token
  },
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js